module.exports = __webpack_public_path__ + "img/ico-alt-quest--blue.694e2cff.svg";